/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AnimaticGauge, AnimaticGauge$inboundSchema } from "./animaticgauge.js";
import { AnimaticLabel, AnimaticLabel$inboundSchema } from "./animaticlabel.js";
import {
  AnimaticPrimitive,
  AnimaticPrimitive$inboundSchema,
} from "./animaticprimitive.js";
import { AnimaticShelf, AnimaticShelf$inboundSchema } from "./animaticshelf.js";

/**
 * Defines the configuration of an animatic. The Animatic is made up of a primitive component, and optional labels, gauges, and a shelf.
 */
export type Animatic = {
  /**
   * The gauges of the animatic.
   */
  gauges?: Array<AnimaticGauge> | undefined;
  /**
   * The labels of the animatic.
   */
  labels?: Array<AnimaticLabel> | undefined;
  /**
   * The misconfigured reasons of the animatic.
   */
  misconfiguredReasons?: Array<string> | undefined;
  /**
   * Defines a primitive animatic component. Primitives are the base of an animatic.
   */
  primitive: AnimaticPrimitive;
  /**
   * Specifies details for a shelf that is displayed with an Animatic.
   */
  shelf?: AnimaticShelf | undefined;
};

/** @internal */
export const Animatic$inboundSchema: z.ZodType<
  Animatic,
  z.ZodTypeDef,
  unknown
> = z.object({
  gauges: types.optional(z.array(AnimaticGauge$inboundSchema)),
  labels: types.optional(z.array(AnimaticLabel$inboundSchema)),
  misconfigured_reasons: types.optional(z.array(types.string())),
  primitive: AnimaticPrimitive$inboundSchema,
  shelf: types.optional(AnimaticShelf$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "misconfigured_reasons": "misconfiguredReasons",
  });
});

export function animaticFromJSON(
  jsonString: string,
): SafeParseResult<Animatic, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Animatic$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Animatic' from JSON`,
  );
}
